/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactCleanProps = _interopRequireDefault(require("@inovua/reactdatagrid-community/packages/react-clean-props"));
var _CheckBox = _interopRequireDefault(require("@inovua/reactdatagrid-community/packages/CheckBox"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var BoolEditor = function BoolEditor(props) {
  var domProps = (0, _reactCleanProps.default)(props, BoolEditor.propTypes);
  return _react.default.createElement("div", _objectSpread({
    className: "InovuaReactDataGrid__cell__editor InovuaReactDataGrid__cell__editor--bool ".concat(domProps.className || '')
  }, domProps), _react.default.createElement(_CheckBox.default, {
    theme: props.theme,
    autoFocus: props.autoFocus,
    defaultChecked: props.value,
    onChange: props.onChange,
    onBlur: props.onComplete,
    onKeyDown: function onKeyDown(e) {
      if (e.key == 'Tab') {
        e.preventDefault();
        props.onTabNavigation && props.onTabNavigation(true, e.shiftKey ? -1 : 1);
      }
    }
  }));
};
BoolEditor.propTypes = {
  onCancel: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onComplete: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onTabNavigation: _propTypes.default.func,
  value: _propTypes.default.any
};
var _default = BoolEditor;
exports.default = _default;